import React, { useContext, useEffect } from "react";
import { ContextProvider } from "../../App";

const SpinLoader = () => {
  const { showSpinLoader, setShowSpinLoader } = useContext(ContextProvider);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSpinLoader(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  return (
    showSpinLoader && (
      <div className="flex items-center justify-center">
        <p className="h-6 w-6 animate-spin rounded-full border-4 border-darkGray border-r-lightGray"></p>
      </div>
    )
  );
};

export default SpinLoader;
